import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  editButton: {
    border: "none !important",
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
  deleteButton: {
    border: "none !important",
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
  ReferencingStatusMissing: {
    color: `${theme.color.white} !important`,
    backgroundColor: `${theme.color.red} !important`,
  },
  // Referiencement partiel supprimé dans le BL-924
  // ReferencingStatusPartial: {
  //   color: `${theme.color.white} !important`,
  //   backgroundColor: `${theme.color.orange} !important`,
  // },
  ReferencingStatusTotal: {
    color: `${theme.color.white} !important`,
    backgroundColor: `${theme.color.green} !important`,
  },
  Badge: {
    padding: "2px",
    borderRadius: "2px",
  },
  DatePicker: {
    width: "100%",
    maxWidth: 140,
  },
  selectInput: {
    flex: 1,
    border: `1px solid ${theme.color.gray2}`,
    paddingLeft: 10,
    paddingRight: 10,
    "&:before": {
      display: "none",
    },
    "& .MuiInput-input": {
      height: 29,
      fontSize: 15,
      display: "flex",
      alignItems: "center",
    },
  },
  NoResultPlaceHolder: {
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& h3": {
      position: "relative",
      top: "-130px",
    },
  },
  footerForm: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
  },
  secondFooterForm: {
    justifyContent: "flex-end",
  },
  fieldsRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: -15,
    marginRight: -15,
    marginBottom: 10,
  },
  /** Same width as OrderForm fields — all standard inputs use this */
  fieldsCol: {
    flex: "1 1 260px",
    maxWidth: 260,
    minWidth: 0,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 4,
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiAutocomplete-root": {
      width: "100%",
    },
  },
  /** Narrow column — Id réception (édition uniquement) */
  fieldsColIdReception: {
    flex: "0 0 160px",
    maxWidth: 160,
    width: 160,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 4,
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiAutocomplete-root": {
      width: "100%",
    },
  },
  /** Narrow column — Date de réception */
  fieldsColDate: {
    flex: "0 0 140px",
    maxWidth: 140,
    width: 140,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 4,
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiAutocomplete-root": {
      width: "100%",
    },
  },
  paperForm: {
    width: "100%",
  },
  paperFormHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 15px",
    borderBottom: "1px solid #dddddd",
  },
  paperFormBody: {
    padding: 15,
  },
  menuCategory: {
    "&.parent": {
      fontWeight: "bold",
      color: theme.color.blue,
    },
    "&.sous-cat": {
      fontWeight: "bold",
      paddingLeft: theme.spacing(5),
    },
    "&.sous-sous-cat": {
      paddingLeft: theme.spacing(7),
    },
  },
  tdPaddingXs: {
    padding: "8px 4px",
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
  productsTableCellHead: {
    minHeight: 40,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  topFormTable: {
    textTransform: "uppercase",
    background: "#F4F5F7 0% 0% no-repeat padding-box",
    borderRadius: "3px 3px 0px 0px",
    "& th": {
      color: "#7A869A",
      lineHeight: "16px",
      fontSize: 13,
    },
    "& th, td": {
      padding: "4px 12px !important",
    },
  },
  bodyFormTable: {
    "& th, td": {
      padding: "4px 12px !important",
      verticalAlign: "top",
      "&:last-child": {
        verticalAlign: "middle",
      },
    },
  },
  formTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
